import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { useUI } from "../lib/i18n";

export default function Footer() {
  const { content } = useContent();
  const ui = useUI();
  return (
    <footer className="border-t border-white/10 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <p className="font-display font-extrabold text-lg flex items-center gap-2">
            <span className="w-2 h-2 bg-[#007AFF] rounded-full" />
            {content?.brand || "Studio AI"}
          </p>
          <p className="mt-2 text-xs text-zinc-600 font-mono tracking-widest uppercase">
            {ui.footer_tagline}
          </p>
        </div>
        <nav className="flex flex-wrap items-center gap-6 text-sm text-zinc-500">
          <Link to="/admin" className="hover:text-white transition-colors" data-testid="footer-link-admin">
            {ui.footer_admin}
          </Link>
        </nav>
        <p className="text-xs text-zinc-600">© {new Date().getFullYear()} {content?.brand || "consulentIA.net"}. {ui.footer_rights}</p>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-8 pt-6 border-t border-white/5">
        <p className="text-sm md:text-base text-white text-center" data-testid="footer-ai-disclaimer">
          Sito generato da AI (Emergent AI) — Testi generati da AI (ChatGPT) e controllati da un umano (io)
        </p>
      </div>
    </footer>
  );
}
